/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SearchableYearsResponse } from '../../models/searchable-years-response';

export interface GetFeV1CalendarSearchableYears$Plain$Params {

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;

/**
 * Unique identifier for tracing the request across services
 */
  'X-Correlation-Id'?: string;
}

export function getFeV1CalendarSearchableYears$Plain(http: HttpClient, rootUrl: string, params?: GetFeV1CalendarSearchableYears$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SearchableYearsResponse>> {
  const rb = new RequestBuilder(rootUrl, getFeV1CalendarSearchableYears$Plain.PATH, 'get');
  if (params) {
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.header('X-Correlation-Id', params['X-Correlation-Id'], {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SearchableYearsResponse>;
    })
  );
}

getFeV1CalendarSearchableYears$Plain.PATH = '/v1/calendar/searchable-years';
